"use client";
import {ScrollableViewport} from "@/components/ui/scrollable-viewport";
import {eventInSingleEventPage} from "@/app/events/store/single-page.store";
import {seatingItemGroups} from "@/app/events/[id]/store/buy-ticket-seating.store";
import {ticketBuyerStaticItemMap} from "@/app/events/[id]/components/seating/TicketBuyerSeatItems";
import {useSignals} from "@preact/signals-react/runtime";

export const SeatArrangement = () => {
    useSignals()

    return (
        <ScrollableViewport widthClass="w-full" heightClass=" h-[30rem]">

            <div className="w-[1200px]">
                <div className="relative" style={{transform: 'translate(2px, 2px)'}}>
                    {seatingItemGroups.value.map((seatingItem) => {
                        const DynamicComponent =
                            // @ts-ignore
                            ticketBuyerStaticItemMap[seatingItem.type as any] ??
                            null;
                        return DynamicComponent ? (
                            <div
                                key={seatingItem.id}
                                className="absolute"
                                style={{
                                    left: seatingItem.x,
                                    top: seatingItem.y,
                                    transform: `scale(${seatingItem.scaleX}, ${seatingItem.scaleY}) rotate(${seatingItem.rotation}deg)`
                                }}
                            >
                                <DynamicComponent {...seatingItem} />
                            </div>
                        ) : null;
                    })}
                </div>
                <img

                    src={eventInSingleEventPage?.value?.seatingImage} className="h-auto w-full block pointer-events-none"
                    draggable={false}
                />

            </div>
        </ScrollableViewport>
    )
}